import React, { useState, useEffect } from 'react';

function Profile() {
  // Create a state variable to store the years since 2005
  const [yearsSince2005, setYearsSince2005] = useState(0);

  // Calculate the years since 2005 when the component mounts
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYearsSince2005(currentYear - 2005);
  }, []);

  return (
    <section id="home" className="intro-profile md-mb50">
      <div className="row rest">
        <div className="col-lg-4 box-img main-bg">
          <div className="cont valign">
            <div className="full-width">
              <div className="img">
                <img src="/assets/imgs/header/praveenSide.png" alt="" />
                <span className="icon">
                  <img src="/assets/imgs/header/icon1.png" alt="" />
                </span>
                <span className="icon">
                  <img src="/assets/imgs/header/icon2.png" alt="" />
                </span>
                <span className="icon">
                  <img src="/assets/imgs/header/icon4.png" alt="" />
                </span>
              </div>
              <div className="info text-center mt-30">
                <h5>Praveen Dubbaka</h5>
                <p className="fz-13 text-u">Available For Freelance</p>
              </div>
              <div className="social text-center mt-20">
                <a href="https://www.behance.net/Praveendub9cfa">
                  <i className="fab fa-behance"></i>
                </a>
                <a href="https://github.com/PraveenDubbaka">
                  <i className="fab fa-github"></i>
                </a>
                <a href="https://ca.linkedin.com/in/praveen-dubbaka-7576684">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="https://dribbble.com/praveendubbaka">
                  <i className="fab fa-dribbble"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-8 content main-bg">
          <h1>
            Hello, I’m <span className="main-color">Praveen Dubbaka</span>, Front-end
            Developer, Generative AI-Enhanced Design and{' '}
            <span className="bord">
              UX / UI Designer <i></i>
            </span>{' '}
            Based in Toronto.
          </h1>
          <div className="stauts mt-80">
            <div className="d-flex align-items-center">
              <div className="mr-40">
                <div className="d-flex align-items-center">
                  <h2>{yearsSince2005} </h2>
                  <p>
                    Years <br /> of Experience
                  </p>
                </div>
              </div>
              <div className="mr-40">
                <div className="d-flex align-items-center">
                  <h2>98</h2>
                  <p>
                    Clients <br /> Worldwide
                  </p>
                </div>
              </div>
              <div>
                <div className="butn-presv">
                  <a href="https://www.icloud.com/iclouddrive/075Pn8TBMLOsA-o3sBq86Owsg#PraveenDubbaka" className="butn butn-md butn-bord radius-5 skew">
                    <span>Download C.V</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Profile;
